import { Navigate, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../Context";
import { AuthContextApi } from "../Context/api";
import Sidebar from "../Components/SideBar";
import Navbar from "../Components/NavBar";
import Footer from "../Components/Footer";

const AuthLayout = ({ Component }) => (
    <div className="h-screen flex flex-col overflow-hidden">
        <Sidebar />
        <Navbar />
        <main className="flex-1 md:pl-64 overflow-y-auto content-scroll flex flex-col">
            <div className="flex-1">
                <Component />
            </div>
            <Footer />
        </main>
    </div>
)


const RouterWrapper = ({ component: Component, isPrivate, isInvestorPrivate = false }) => {
    const { states, setters } = useContext(AuthContext)
    const { checkLogin, checkLoginInvestidor } = useContext(AuthContextApi)
    const navigate = useNavigate()
    const [investidorChecked, setInvestidorChecked] = useState(false)


    const isSigned = async () => {
        const token = localStorage.getItem('token')
        if (token === null) {
            setters.setSigned(false)
        } else {
            const response = await checkLogin()
            if (response === true) {
                setters.setSigned(true)
            } else {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                navigate('/')
            }

        }
    }

    useEffect(() => {
        if (isInvestorPrivate) {
            const isSignedInvestidor = async () => {
                const response = await checkLoginInvestidor()
                setters.setSignedInvestidor(response === true)
                setInvestidorChecked(true)
                if (response !== true) {
                    navigate('/investidor/login')
                }
            }
            isSignedInvestidor()
            return
        }
        isSigned()
    }, [localStorage.getItem('token')])


    if (isInvestorPrivate) {
        if (!investidorChecked && !states.signedInvestidor) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="w-8 h-8 border-2 border-gray-200 border-t-gray-900 rounded-full animate-spin" />
                </div>
            )
        }
        if (states.signedInvestidor) return <Component />
        return <Navigate to='/investidor/login' />
    }


    if (isPrivate) {
        if (states.signed) return <AuthLayout Component={Component} />
        if (localStorage.getItem('token') === null) return <Navigate to='/' />
        return <AuthLayout Component={Component} />
    }

    if (isPrivate && !states.signed) {
        return (
            <Navigate to='/' />
        )
    }

    if (isPrivate && states.signed) {
        return (
            <Navigate to='/dashboard' />
        )
    }

    if (!isPrivate) {
        return (
            <Component />
        )
    }
    return (
        <Component />
    )



}

export default RouterWrapper;